import React, {useEffect} from 'react'

/**
 * The code here is a vendor-provided snippet with the exception of `this` -> `globalThis` in the parameters of this
 * gross inline function. That change was necessary to make it work inside a React component.
 */
export const ProdPerfectTracker = props => {
    useEffect(() => {
        if(PROD_PERFECT_TRACKING_ENABLED) {
            !function (name, path, ctx) {
                var latest, prev = name !== 'Keen' && window.Keen ? window.Keen : false;
                ctx[name] = ctx[name] || {
                    ready: function (fn) {
                        var h = document.getElementsByTagName('head')[0], s = document.createElement('script'),
                            w = window, loaded;
                        s.onload = s.onreadystatechange = function () {
                            if ((s.readyState && !(/^c|loade/.test(s.readyState))) || loaded) {
                                return
                            }
                            s.onload = s.onreadystatechange = null;
                            loaded = 1;
                            latest = w.Keen;
                            if (prev) {
                                w.Keen = prev
                            } else {
                                try {
                                    delete w.Keen
                                } catch (e) {
                                    w.Keen = void 0
                                }
                            }
                            ctx[name] = latest;
                            ctx[name].ready(fn)
                        };
                        s.async = 1;
                        s.src = path;
                        h.parentNode.insertBefore(s, h)
                    }
                }
            }('ProdPerfectKeen', 'https://govdocs.trackinglibrary.prodperfect.com/keen-tracking.min.js', globalThis);


            ProdPerfectKeen.ready(function () {
                var client = new ProdPerfectKeen({
                    projectId: "CyI2NlNq54fcRt16aRDkeJBt",
                    writeKey: "W4Y1ZN2FM4UUXMTMAWP41V7QZZ8H6SBQXTA43D0102ZOZKOZZVV3NZ6KNBJJFRM23Q6EC7P34RDNCMBI37GDE7H3F6VJ4FQRLADIMYFP0CQY58VVZG37UC03OLFSU41BXPSYE9TUM4CJ3KHG3PD4ISYVWLSLZ8C6XDH2KYTKTFKRMDNKGCXUZ6ZCI9NU42K4",
                    requestType: "beacon",
                    host: "govdocs.datapipe.prodperfect.com/v1"
                });

                client.extendEvents({
                    visitor: {
                        user_id: null
                    }
                });

                var options = {
                    ignoreDisabledFormFields: false,
                    recordClicks: true,
                    recordFormSubmits: true,
                    recordInputChanges: true,
                    recordPageViews: true,
                    recordPageUnloads: true,
                    recordScrollState: true
                };
                client.initAutoTracking(options);
            });
        }
    },[props.launchTracker])

    return null
}
